const ROUTING_KEY_PARAM = 'routing_key';

const getParamFromLocation = (location: Location, name: string): string | undefined => {
  const fromSearch = new URLSearchParams(location.search).get(name);
  if (fromSearch) return fromSearch;

  const hash = location.hash;
  const queryStart = hash.indexOf('?');
  if (queryStart === -1) return undefined;

  return new URLSearchParams(hash.slice(queryStart + 1)).get(name) ?? undefined;
};

/**
 * Reads the `routing_key` identifier used for Advanced Quote Request routing.
 *
 * The value is forwarded to the API as the `routing_key` query param, which the server
 * matches (case-insensitively) against the uploaded routing mapping. When embedded in an
 * iframe the host page's `?routing_key` takes precedence over the configurator's own URL,
 * mirroring how the currency parameter is resolved (see getUrlCurrency).
 */
export function getUrlRoutingKey(
  location: Location = window.location,
  hostLocation?: Location | null,
): string | undefined {
  const hostRoutingKey = hostLocation ? getParamFromLocation(hostLocation, ROUTING_KEY_PARAM) : undefined;
  const ownRoutingKey = getParamFromLocation(location, ROUTING_KEY_PARAM);

  return hostRoutingKey ?? ownRoutingKey;
}
